var React = require('react');

function China (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#DE2910","d":"M44 0H4a4 4 0 00-4 4v24a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4z","key":0}),React.createElement("path",{"fill":"#FFDE00","d":"M8 3.2l2.8 8.7-7.4-5.4h9.2L5.2 12 8 3.2zM14.6 4l2-2.3-.2 3-1.6-2.6 2.8 1.2-3 .7zM17.6 6.6l2.7-1.3L19 8l-.4-3L20.6 7l-3-.5zM17.7 10.8l3-.1-2.4 1.8.8-2.9 1 2.9-2.4-1.7zM14.8 13.4l2.8 1-3 .9 2-2.4-.2 3-1.6-2.5z","key":1})]);
}

China.defaultProps = {"fill":"none","viewBox":"0 0 48 32"};

module.exports = China;

China.default = China;
